class MsrpUri {
  constructor(userInfo, host, port, sessionId, transport, role, companyDomain) {
    this.companyDomain = companyDomain || "";
    this.scheme = "msrp";
    this.userInfo = userInfo || "";
    this.host = host || "";
    this.port = port || "";
    this.sessionId = sessionId || "";
    this.transport = transport || "";
    this.role = role || "";
  }

  setScheme(scheme) {
    this.scheme = scheme;
    return this;
  }

  setUserInfo(userInfo) {
    this.userInfo = userInfo;
    return this;
  }

  setHost(host) {
    this.host = host;
    return this;
  }

  setPort(port) {
    this.port = port;
    return this;
  }

  setSessionId(sessionId) {
    this.sessionId = sessionId;
    return this;
  }

  setTransport(transport) {
    this.transport = transport;
    return this;
  }

  setRole(role) {
    this.role = role;
    return this;
  }

  setcompanyDomain(companyDomain) {
    this.companyDomain = companyDomain;
    return this;
  }
  toString() {
    let uri = `${this.scheme}://`;

    if (this.userInfo !== "") {
      uri += `${this.userInfo}@`;
    }

    if (this.host !== "") {
      uri += this.host;
    }

    if (this.port !== "") {
      uri += `:${this.port}`;
    }

    if (this.sessionId !== "") {
      uri += `/${this.sessionId}`;
    }

    if (this.transport !== "") {
      uri += `;${this.transport}`;
    } else {
      uri = uri.replace(/;$/, "");
    }

    if (this.role !== "") {
      uri += `;role=${this.role}`;
    }
    if (this.companyDomain !== "") {
      uri += `;company-domain=${this.companyDomain}`;
    }

    return uri;
  }
}

export default MsrpUri;
